type CsaCardBodyProps = {
  title: string;
  text: string;
};

const CsaCardBody = ({ title, text }: CsaCardBodyProps) => {
  return (
    <div className="csa-card-container">
      <h3>{title}</h3>
      <p className="csa-card-text">{text}</p>
    </div>
  );
};

export default CsaCardBody;
